import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

export const Star = ({ color, size, x = '0px', y = '0px', scale = 0 }: IconProps) => {
  return (
    <StyledSvg
      xmlns="http://www.w3.org/2000/svg"
      width={size || '22px'}
      height={size || '22px'}
      color={color || 'currentColor'}
      scale={scale || 0}
      x={x}
      y={y}
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M8.40678 8.75752L11 2.62064L13.5932 8.75752H20L14.9661 13.1945L16.9492 19.3794L11 15.4802L5.05085 19.3794L7.0339 13.1945L2 8.75752H8.40678Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.5"
      />
    </StyledSvg>
  );
};
